import { Pipe, PipeTransform } from '@angular/core';
import { LocalizationService } from '../services/localization.service';

@Pipe({
  name: 'filterBy',
})
export class FiltersPipe implements PipeTransform {
  all_lang = {
    en: 'All',
    tr: 'Hepsi',
    ar: 'الكل',
    de: 'Alle',
    es: 'Todas',
    fa: 'همه',
    ku: 'هه موو',
    vi: 'Tất cả',
    fr: 'Tous',
    hr: 'Svi',
    cs: 'All',
    sk: 'All',
    ru: 'Все',
    pl: 'Wszystko',
    el: 'Όλα',
    bg: 'Всички',
    da: 'Alle',
    sr: 'Sve',
    pt: 'Tudo',
    ro: 'Toate',
    sq: 'Të gjitha',
  };

  constructor(private _ls: LocalizationService) {}

  transform(items: any[], key: any, value: any): any {
    if (!value) {
      return items;
    }
    if (this.all_lang[this._ls.LANGCODE] == value) {
      return items;
    }
    if (typeof value === 'object') {
      return items.filter(x => value.includes(x));
    }

    return items.filter(x => x[key] == value);
  }
}
